import _get from 'lodash/get';
import _has from 'lodash/has';
export default {
  data() {
    return {
      automatedEmailData: {
        eventType: '',
        timeFrame: '',
        sentEmails: [],
        sentCount: 0,
        openedCount: 0,
      },
    };
  },
  methods: {
    getAutomatedEmailData(emailObj) {
      const { eventType, dataKey, page } = emailObj;
      let parsedDays = 0;

      if (_has(emailObj, 'days')) {
        parsedDays = emailObj.days;
      }

      const timeFrame = {
        'Upcoming Events': 'upcoming',
        'Calendar Live Events': 'live',
        'Live Events': 'live',
        'Past Events': 'past',
      };

      let data = _get(this, dataKey, {
        sentEmails: [],
        sentCount: 0,
        openedCount: 0,
      });

      this.automatedEmailData = {
        page,
        eventType,
        timeFrame: timeFrame[page],
        sentEmails: data.sentEmails,
        sentCount: data.sentCount,
        openedCount: data.openedCount,
        daysOut: parsedDays,
      };
    },
  },
};
